import { useLazyQuery } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import GetCustomersLookupQuery from '@/graphql/contracts/getCustomersLookUp.query.gql';

import { notificationService } from '@/services/notification/notification.client';
import { GetCustomersLookup, GetCustomersLookupVariables } from
  '@/graphql/contracts/_generated_/getCustomersLookUp.query';
import { CustomerLookupOutput } from '@/graphql/contracts/_generated_/contracts';

const CUSTOMER_RESULTS_TO_SHOW = 10;

export default function useGetCustomersLookUp() {
  const [_getCustomers, { data, loading }] = useLazyQuery<GetCustomersLookup,
  GetCustomersLookupVariables>(
    GetCustomersLookupQuery,
    {
      client: apolloClientContracts,
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
      fetchPolicy: 'network-only'
    }
  );

  const getCustomersLookUp = (search: string) => {
    return _getCustomers({
      variables: {
        filter: {
          summary: search,
        },
        first: CUSTOMER_RESULTS_TO_SHOW,
      },
    });
  };


  return {
    getCustomersLookUp,
    customers: data?.customerGrid?.lists?.customersLookup?.items as CustomerLookupOutput[],
    isCustomersLookUpLoading: loading
  } as const;
}
